module.exports = __webpack_public_path__ + "static/img/shanghai.d51ec47.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/GeographyMasthead/images/shanghai.jpg
// module id = T/X7
// module chunks = 1